import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";

export const Route = createFileRoute("/privacidade")({
  head: () => ({
    meta: [
      { title: "Privacidade — Viny Club" },
      {
        name: "description",
        content: "Saiba como a Viny Club protege seus dados e respeita sua privacidade.",
      },
    ],
  }),
  component: Privacidade,
});

function Privacidade() {
  return (
    <AppShell>
      <PageHeader
        eyebrow="Segurança"
        title="Privacidade"
        subtitle="Seus dados são seus. Sempre."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 lg:px-8">
        <article className="space-y-8 text-foreground/90">
          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">1. Dados que coletamos</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Coletamos apenas o necessário para o funcionamento da plataforma: e-mail, nome de usuário, foto de perfil, cidade (opcional), dados da sua coleção de discos e interações no feed. Não vendemos dados para terceiros.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">2. Uso das informações</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Utilizamos seus dados para exibir seu perfil e coleção, gerar rankings, conectar você com outros colecionadores e personalizar recomendações de discos. Dados de pagamento são processados diretamente pelo Stripe e não ficam armazenados em nossos servidores.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">3. Compartilhamento</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Seu perfil público, coleção e lista de desejos ficam visíveis para outros usuários conforme suas configurações de privacidade. Informações privadas — como e-mail e dados de pagamento — nunca são expostas.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">4. Cookies e rastreamento</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Usamos cookies essenciais para autenticação e funcionalidades da plataforma. Cookies de análise são utilizados de forma agregada e anônima para melhorar a experiência. Você pode gerenciar preferências no seu navegador.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">5. Seus direitos</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento através das configurações da conta ou enviando um e-mail para <strong>suporte@viny.club</strong>.
            </p>
          </section>

          <p className="text-xs text-muted-foreground">
            Última atualização: {new Date().getFullYear()}.
          </p>
        </article>
      </div>
    </AppShell>
  );
}
